import { PurchaseInfoDto, PurchaseDto } from '@sr/dto';
import { ReactNode } from 'react';
import { Link } from '../link-base';
import { purchaseLinkManager } from 'utils/link-manager';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Button, Box } from '@mui/material';

export const LinkToPurchase = (props: { purchase: PurchaseInfoDto | PurchaseDto, children?: ReactNode; }) => {
  const { purchase: { id }, children } = props;

  const link = purchaseLinkManager.link(id);

  if (children)
    return (
      <Link to={link}>
        {children}
      </Link>);

  return (
    <Link 
      to={link} 
      sx={{ 
        fontSize: 20, 
        fontWeight: 'bold',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'none'
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {id}
        <Button variant="outlined" startIcon={<LockOpenIcon />} color="success" size="small">
          Открыть
        </Button>
      </Box>
    </Link>
  );
};
